import React from 'react';
import { useTrackSection } from '../utils/useTrackSection';
export function ProductShowcase() {
  useTrackSection('product-showcase', 'Product Showcase Section');
  return <section id="product-showcase" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(248,250,252) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 75%, rgb(240,253,244) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-184">
      <div className="mx-auto max-w-4xl text-center" data-id="element-185">
        {/* Badge */}
        <div className="mb-4 inline-flex items-center gap-2 text-xs font-bold tracking-wide rounded-full px-4 py-1.5 border border-green-600/50 bg-green-700/5 text-green-700" data-id="element-186">
          🏆 El sistema de organización profesional para nutricionistas
        </div>

        {/* Title */}
        <h2 className="text-2xl font-black text-gray-900 m-0 mb-2" data-id="element-187">
          MEGAPACK NUTRICIÓN RESUELTA
        </h2>

        {/* Subtitle */}
        <p className="text-sm font-semibold text-gray-700 m-0 mb-4" data-id="element-188">
          6 Tomos + 5 Bonos para dejar de improvisar consultas, organizar mejor
          tu consultorio y ahorrar tiempo cada semana.
        </p>

        {/* Summary */}
        <p className="text-xs sm:text-sm font-bold text-green-700 m-0 leading-6" data-id="element-189">
          +350 páginas · Primera consulta · Planificación · Seguimiento ·
          Educación alimentaria · Acceso inmediato
        </p>
      </div>
    </section>;
}